export const companyCountList = [3327, 3320, 3322, 3324, 3321, 3323, 3325, 3326];

export default {
  companyCountList,
};
